const contractAgentsActions = {
  CONTRACT_AGENTS_INIT: 'CONTRACT_AGENTS_INIT',
  CONTRACT_AGENTS_SET: 'CONTRACT_AGENTS_SET'
};

export default contractAgentsActions;